import r from "react";
import t from "prop-types";
import { D as m } from "./DayPicker-BTgVNC2J.es.js";
import { M as l } from "./MonthPicker-DVwW-q2g.es.js";
import { a } from "./propTypes-DVvgo52A.es.js";
const o = (e) => {
  const n = e.showDays ? m : l;
  return /* @__PURE__ */ r.createElement(
    n,
    {
      start: e.date,
      end: null,
      onSetEnd: () => null,
      onSetStart: e.onSelect,
      minDate: e.minDate,
      maxDate: e.maxDate,
      rangeMode: !1
    }
  );
};
o.propTypes = {
  /** The callback prop triggered when the selected date is changed.  */
  onSelect: t.func.isRequired,
  /** Allows a day to be selected, as opposed to a month. */
  showDays: t.bool,
  /** The currently-selected date. Should be of shape `<dayPropType>`
   * if showDays is true, `<monthPropType>` otherwise
   */
  date: a,
  /** Maximum date that can be selected. Dates after this will be greyed out. */
  maxDate: a,
  /** Minimum date that can be selected. Dates before this will be greyed out. */
  minDate: a
};
o.defaultProps = {
  date: null,
  showDays: !1,
  minDate: null,
  maxDate: null
};
export {
  o as S
};
